import { FaClock, FaMapMarkerAlt, FaUserTie } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import {  } from "react-icons";
function Schedule() {
  return (
    <div className="schedule section">
      <h2 className="title">
        <img src="images/yodogawa-10.png" alt="スケジュール" />
      </h2>
      <ul>
        <li>
          <div className="kouza">
            <div className="date">10月21日（土）</div>
            <h3>
              プライベートガイドの高付加価値化 ～滋賀県での取り組みを通じて～
            </h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">悠ツアー　森聖太</span>
            </p>
            <p className="main-text">
              滋賀県で上質な体験を提供するプライベートツアーを行っている悠ツアーの森聖太様に「プライベートガイドの高付加価値化」について話をしていただきます。
              滋賀県といえば琵琶湖をイメージされがちですが、悠ツアーの特徴は地域の普通の人たちとの交流を主にして、地域の根強いファンを作るという活動をされております。
              第三回目の講師であるオダギリさん曰く「森さんのツアーはすごい！！でも、あれはなかなか真似できない！」とまで言っています。何が真似できないのか。この講座に参加してその目で確かめてください。
            </p>
            <div className="info">
              <FaClock />
              <div className="time">10:00-12:30</div>
              <FaMapMarkerAlt />
              <div className="loc">さくらであい館</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza">
            <div className="date">10月21日（土）</div>
            <h3>歴史から見る船場・大阪城・淀川</h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">
                一般社団法人アーバンツーリズム大阪・船場　久保田正義
              </span>
            </p>
            <p className="main-text">
              「大坂・忍び文化観光プロジェクト」を手掛ける一般社団法人アーバンツーリズム大阪・船場の久保田正義様に話をしていただきます。なぜ、大阪で忍者？と思われる方もいるかと思いますが、大阪城の歴史、その城下町である船場の成り立ち、情報を握る忍者。そういった歴史的なものを現在のコンテンツとして作り上げ、訪日外国人旅行者をはじめとした交流人口の拡大を目指しています。
              淀川＋大阪城＋忍者という新しいコンテンツの話を聞いてみませんか？
            </p>
            <div className="info">
              <FaClock />
              <div className="time">13:30-16:00</div>
              <FaMapMarkerAlt />
              <div className="loc">さくらであい館</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza">
            <div className="date">10月28日（土）</div>
            <h3>地域のファンの作り方 ～ふるシェアの取り組み～</h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">
                ㈱インプリージョン　オダギリサトシ
              </span>
            </p>
            <p className="main-text">
              日本中に「友だち」のいる「ふるさと」を。旅行以上、移住未満で日本中の関係人口になる。をテーマに、日本中の「ふるさと」と「まち」を繋ぐサービスを提供しているオダギリさんのお話です。
              これからの観光か、みんなが行ったことのある場所、有名な場所を訪れるのではなく、地域のファンを作ることが大事です。
              今回はそんなオダギリさんの取り組みをお話しいただきます。
            </p>
            <div className="info">
              <FaClock />
              <div className="time">10:00-12:30</div>
              <FaMapMarkerAlt />
              <div className="loc">レンタルスペースビィーゴ</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza">
            <div className="date">10月28日（土）</div>
            <h3>"大人の外遊び"で日本に元気を！</h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">㈱ソトアソ　菊川光徳</span>
            </p>
            <p className="main-text">
              交野の里山を中心にトレイルランニングなどのマウンテンスポーツ、ノルディックウォーキングやパドルボードなどのアクティビティプログラムを提供するソトアソの菊川さんのアウトドアを活用した地域の活動事例を紹介していただきます。
              現在は私市駅前の改札を出てすぐに里山体験ができる「キサイチゲート」の取り組みをしています。
            </p>
            <div className="info">
              <FaClock />
              <div className="time">13:30-16:00</div>
              <FaMapMarkerAlt />
              <div className="loc">レンタルスペースビィーゴ</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza">
            <div className="date">11月11日（土）</div>
            <h3>地域ＸインバウンドＸ高付加価値化　淀川における取り組み</h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">
                ㈱JTBコミュニケーションデザイン福村和広
              </span>
            </p>
            <p className="main-text">
              「高付加価値化」と聞いて皆さんは何を想像しますか？値段を上げること？それだけではありません。
              安くてソコソコのプログラムの提供をするのではなくて、「ここだけでしか体験できないこと」を提供することによって相応の対価を頂いて、お客様の満足度を上げていく活動です。
              現在、全国で高付加価値化の活動が行われていますが、淀川を中心とした事例の紹介などを含めたお話をしていただきます。
            </p>
            <div className="info">
              <FaClock />
              <div className="time">10:00-12:30</div>
              <FaMapMarkerAlt />
              <div className="loc">大阪産業創造館</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza">
            <div className="date">11月11日（土）</div>
            <h3>まち歩き視察　淀川と商都大阪　船場・道修町</h3>
            <p className="main-text">
              <FaUserTie />
              <span className="speaker-name">㈱マイドマインド　山本訓弘</span>
            </p>
            <p className="main-text">
              最終回は会場から飛び出し、船場・道修町・北浜を散策し、「舟運＋まち歩き＋高付加価値化」を参加者の皆さんと一緒に考えていくプログラムです。
              この付近は現在ではオフィス街ですが、かつては大坂だけでなく日本の経済の中心地出会った場所です。歴史的な建築物も多く、淀川水系の川も流れ込んでいます。
              これらを実際に視察しながら、高付加価値化のヒントを掴んでみましょう。
            </p>
            <div className="info">
              <FaClock />
              <div className="time">13:30-16:00</div>
              <FaMapMarkerAlt />
              <div className="loc">大阪産業創造館</div>
            </div>
          </div>
        </li>
        <li>
          <div className="kouza coming-soon">
            <h3 className="workshop-title">
              <span className="shoulder">
                淀川を活用した観光コンテンツ造成事業
              </span>
              <br />
              講座終了後もしっかり学べるワークショップを開催！
            </h3>
            <a className="apply-button" href={`/workshop`}>
              開催概要ページ
            </a>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default Schedule;
